module.exports = __webpack_public_path__ + "static/media/testimonial-chris.f8dd04db.png";